
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-css-theme-switcher.cjs.production.min.js')
} else {
  module.exports = require('./react-css-theme-switcher.cjs.development.js')
}
